import { Box, Text } from "grommet";
import React, { CSSProperties } from "react";
import { StyleSheet } from "../../../../../../../typings/StyleSheet";
import StandardColors from "../../../../../../../util/StandardColors";
import StandardFonts from "../../../../../../../util/StandardFonts";
import TitleText from "./TitleText";
import gender from "../../../../../../../assets/gender.png";

type PropertyDisplayFieldPropsType = {
  title: string;
  valueComponent?: React.ReactNode;
  style?: CSSProperties;
};

const PropertyStatusField = ({
  title,
  valueComponent,
  style
}: PropertyDisplayFieldPropsType) => {
  return (
    <Box style={{ ...styles.container, ...style }}>
      <Box style={{...styles.icon}}>
        <TitleText parentInfo="complaint" title={title} />
      </Box>
      {
        valueComponent && (
          valueComponent
        )
      }
    </Box>
  );
};

export default PropertyStatusField;

const styles: StyleSheet = {
  icon: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 10
  },
  container: {
    display: "flex",
    // marginRight: 40,
    justifyContent: 'center',
    // marginLeft: 10
  },
  value: {
    textAlign: 'center',
    color: StandardColors.black_100,
    ...StandardFonts.h51624Medium,
  },
};
